<template>
  <div>
    <div class="top" v-if="false">
      <p style="overflow: hidden;" @mouseleave="leave(500)" @mouseenter="enter">
        <img src="~@/assets/home/all.png" alt class="all" />
        <span>产品与服务</span>
      </p>
      <transition name="fade">
        <div class="top-menu" v-if="show" @mouseleave="leave(100)" @mouseenter="enter">
          <el-scrollbar wrap-class="list" style="height: 100%;">
            <p class="search" v-if="false">
              <i class="el-icon-search"></i>
              <input type="text" placeholder="请输入关键词" />
            </p>
            <div class="lately">
              <h5>最近访问</h5>
              <el-row>
                <el-col :span="6" v-for="(item, index) in commonMenu" :key="index">
                  <a @click="clickTopNav(item.path,item.title,item.parent, item.icon, item.id, item.currentPage)">
                    {{item.title}}
                    <span>{{item.parent?'('+item.parent+')':''}}</span>
                  </a>
                </el-col>
              </el-row>
            </div>
            <el-row class="service-list">
              <el-col :span="24" v-for="(item, index) in allMenu" :key="index">
                <h5 :style="{cursor:item.Url?'pointer':''}" @click="clickParent(item)">{{item.Title}}</h5>
                <el-col :span="6" v-for="(child, ii) in item.children" :key="ii">
                  <a @click="clickTopNav(child.Url,child.Title,item.Title, child.ICon, child.ID, child.IsCurrentPageOpen)">{{child.Title}}</a>
                </el-col>
              </el-col>
            </el-row>
          </el-scrollbar>
        </div>
      </transition>
    </div>
    <el-scrollbar wrapClass="scrollbar-wrapper" style="overflow-x:hidden;">
      <el-menu mode="vertical" :show-timeout="200" :default-active="$route.path" :collapse="false" background-color="#001529" text-color="#fff" active-text-color="#fff">
        <sidebar-item v-for="route in routes" :key="route.name" :item="route" :base-path="route.path"></sidebar-item>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import { getCookie } from '@/base/cookie'

import {
  getProductUrl,
  getListOperations,
  setListOperations,
  getAllMenu
} from '@/api/index'
import SidebarItem from './SidebarItem'

export default {
  data () {
    return {
      defaultRoute: '',
      timer: null,
      show: false,
      commonMenu: [],
      allMenu: [],
      menuList: []
    }
  },
  components: {
    SidebarItem
  },
  computed: {
    ...mapGetters(['sidebar']),
    routes () {
      return this.$router.options.routes
    },
    isCollapse () {
      return !this.sidebar.opened
    },
    userId () {
      return this.$store.state.user.staffInfo.id
    }
  },
  mounted () {
    if (!(this.$route.query.token || getCookie('ERP-Token'))) {
      this.getAllMenu()
    }
    const self = this
    document
      .getElementsByClassName('sidebar-container')[0]
      .addEventListener('mouseleave', function (e) {
        if (self.show) {
          self.show = false
        }
      })
  },
  methods: {
    clickParent (item) {
      if (item.Url) {
        this.clickTopNav(
          item.Url,
          item.Title,
          '',
          item.ICon,
          item.ID,
          item.IsCurrentPageOpen
        )
      }
    },
    leave (val) {
      // this.timer = setTimeout(() => {
      // 	this.show = false;
      // }, val);
    },
    enter () {
      this.show = true
    },
    clickTopNav (path, title, parent, icon, id, currentPage) {
      setListOperations({ path, title, parent, icon, id, currentPage }).then(
        (res) => {
          if (path && currentPage) {
            window.location.href = path
          } else if (path !== null) {
            window.open(path)
          }
        }
      )
    },
    async getAllMenu () {
      const result = await getAllMenu()

      const result2 = await getProductUrl()

      const result3 = await getListOperations()

      this.menuList = result.data
      this.commonMenu = result3.data
      result.data.forEach((item) => {
        if (item.ParentID === 0) {
          this.allMenu.push(item)
          this.$set(item, 'children', [])
        } else {
          var parent = this.allMenu.filter((e) => {
            return e.ID === item.ParentID
          })[0]
          parent.children.push(item)
        }
      })
      result2.data.forEach((e) => {
        this.menuList.forEach((item) => {
          if (item.ID === e.ID) {
            item.Url = e.Url
          }
        })
        this.commonMenu.forEach((item) => {
          if (item.id === e.ID) {
            item.path = e.Url
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.is-horizontal {
  display: none;
}
.siderbar {
  position: fixed;
  height: 100%;
  margin-top: 64px;
}

.sidebar-container_list {
  background: rgba(0, 21, 41, 1);
}
.el-menu-vertical-demo .icon {
  width: 15px;
  margin-left: 15px;
  margin-right: 25px;
  -webkit-filter: brightness(100%);
  /* Chrome, Safari, Opera */
  filter: brightness(100%);
}

.el-menu-vertical-demo /deep/ .el-menu-item.is-active {
  background-color: #4c8deb;

  .icon {
    -webkit-filter: brightness(200%);
    /* Chrome, Safari, Opera */
    filter: brightness(200%);
  }
}

.menu-item {
  padding: 0 10px !important;
  height: 57px;
  color: rgb(191, 203, 217);
}

.top {
  white-space: nowrap;
  height: 57px;
  color: rgb(191, 203, 217);
  position: relative;
  border-bottom: 1px solid #182b3d;
  border-top: 1px solid #182b3d;
}

.top > p {
  line-height: 57px;
  cursor: pointer;
}

.top .all {
  margin: 0 25px;
  font-size: 18px;
  width: 15px;
}

.top-menu {
  position: absolute;
  left: 225px;
  top: 0;
  background-color: #fff;
  padding: 20px;
  height: calc(100vh - 65px);
  width: 700px;
  border-left: 1px solid #fff;
  // display: none;
  color: #333;
  box-shadow: 0 0 10px #999;

  /deep/ .el-scrollbar__wrap {
    overflow-x: hidden;
  }

  /deep/ .el-col-6 {
    cursor: pointer;
  }

  /deep/ .el-col-6:hover {
    background: rgba(215, 215, 215, 0.5);
  }

  .search {
    width: 700px;
    background-color: #fff;
    height: 40px;
    border-bottom: 1px solid #4c8deb;
    padding: 0 10px;

    input {
      float: left;
      height: 100%;
      width: 90%;

      &::-webkit-input-placeholder {
        /* placeholder颜色  */
        color: #aab2bd;
        /* placeholder字体大小  */
        font-size: 12px;
        /* placeholder位置  */
        text-align: left;
      }
    }

    i {
      float: left;
      padding: 0;
      font-size: 20px;
      color: #999;
      margin-top: 10px;
      margin-right: 10px;
    }
  }
}

.lately {
  h5 {
    font-size: 16px;
    font-weight: 700;
    color: #333;
    margin: 20px 0;
    padding: 0 20px;
  }

  .el-col {
    height: 35px;
    line-height: 35px;
    color: #5a5a5a;
  }

  a {
    padding: 0 20px;
    display: block;
    span {
      font-size: 12px;
      color: #999;
    }
  }
}

.service-list {
  h5 {
    font-size: 16px;
    color: #333;
    clear: both;
    margin-top: 15px;
    padding: 0 20px;
  }

  .el-col {
    color: #5a5a5a;
    line-height: 35px;

    .el-col-24 {
      padding: 0 20px;
    }
  }

  .el-col-24 {
    .el-col-6 {
      a {
        display: block;
        padding: 0 20px;
      }
    }
  }

  .mt-40 {
    margin-top: 40px;
  }
}
</style>
